import React, { Component } from 'react'
import { connect } from 'react-redux'
import logo from '../../images/icons/ico_me_melia.svg'
import { CMSPath, DEVICEREGFORMENABLED } from '../../../config/constant'
import { setAdminLoginPage, showConfirmationPage } from '../../action/homeAction'
import { setRegPage } from '../../../action/action'
import PropTypes from 'prop-types';
import $ from 'jquery';
import { scrollDownEffect,removeScrollDown } from '../roomControl2/scrollEffect';
import { guestJourneyNotification } from '../../../action/homeAction';
import { HashRouter, Redirect, Router } from 'react-router-dom'
import { scrollUpListenerToShowHideElement, scrollUpListener } from '.././roomControl2/scrollEffect'

class StickyHeader extends Component {
    constructor(props) {
        super(props);
        this.logoClickTimeOut = 0
        this.room = localStorage.getItem("room");
        this.state = {
            logoClickCount: 0,
            eventTouch: "click",
            touchY: 0,
            imageHeight: 200,
            autocheckinSelfie:null,
            changeProfileImage: false
        }
        this.headerHeight = null;
        this.startY = 0;
    }
    logoClick = () => {

        if(DEVICEREGFORMENABLED){

        window.clearTimeout(this.logoClickTimeOut);
        if (this.state.logoClickCount >= 5) {
            this.props.setAdminLoginPage(true);
        } else {
            this.setState({ logoClickCount: this.state.logoClickCount + 1 })
        }
        this.logoClickTimeOut = window.setTimeout(
            () => { this.setState({ logoClickCount: 0 }) }, 2000
        )}
    }

    profileClick = () => {
        // this.props.showConfirmationPage(true, "header","thanks for the message.");
        if(process.env.REACT_APP_INROOMTAB != "true"){
        const room = localStorage.getItem('room');
        if(room && room != "null"){
            this.setState({changeProfileImage:true})
        }else{
            this.props.setRegPage(true);
        }}
    }
    getLine1 = () => {
        let roomNum = localStorage.getItem("room")

        // Milind: GJ 2.0 fixed: After login successfully, try to login with wrong details, it shows "#Guest_name" instead of "Thank you......"
        // For Not log in / Log in failed show Hi, \n Welcome, please log in to access more features.
        if (!roomNum || roomNum === "null") {

            if (this.props.profile.greetingsLine3) {
                let line1 = this.props.profile.greetingsLine3.trim()
                    // return line1.replace("#GUEST_NAME#", ','); // Just replace '#GUEST_NAME#' with 'Hi, ' text
                    return "";
                }
        } else {
            if (this.props.profile.greetingsLine3) {
                let line1 = this.props.profile.greetingsLine3.trim()
                if(this.props.guestName){
                    return `${line1} ${this.props.guestName}`
                } else {
                    return line1
                }
                // if (line1.indexOf("#GUEST_NAME#") !== -1 && this.props.guestName) {
                //     return line1.replace("#GUEST_NAME#", this.props.guestName);
                // } else if (line1.indexOf("#ROOM#") !== -1) {
                //     if (roomNum && roomNum !== "null") {
                //         return line1.replace("#ROOM#", roomNum);
                //     } else {
                //         line1 = null
                //     }
                // } else {
                //     return line1
                // }
            }
        }
    }

    getLine2 = () => {
        let roomNum = localStorage.getItem("room")
        // Milind: 
        // If !LoggedIn > Line2, else Line4.
        console.log('this.props.profile.greetingsLine1',this.props.profile.greetingsLine1)

        if (!roomNum || roomNum === "null") {
            if (this.props.profile.greetingsLine1) {
                let line2 = this.props.profile.greetingsLine1.trim();
                return line2; // return line2 to show 'Welcome, please log in to access more features' or Logged in text as before.
            }
        }
        else {
            if (this.props.profile.greetingsLine4 && typeof this.props.profile.greetingsLine4 === "string" ) {
                console.log('this.props.profile.greetingsLine4',this.props.profile.greetingsLine4)
                let line4 = this.props.profile.greetingsLine4.trim();
                if (line4.indexOf("#GUEST_NAME#") !== -1 && this.props.guestName) {
                    return line4.replace("#GUEST_NAME#", this.props.guestName);
                } else if (line4.indexOf("#ROOM#") !== -1) {
                    if (roomNum && roomNum !== "null") {
                        return line4.replace("#ROOM#", roomNum);
                    } else {
                        line4 = null
                    }
                }
                else {
                    return line4
                }
            }
        }
    }
 
    refreshNotification = (height) => {

        console.log("refresh Notification callback")
        const sessionToken = localStorage.getItem('GuestJourneySessionToken');
        if(this.props.currentHomePage.label === "NOTIFICATIONS"){
            this.props.guestJourneyNotification(sessionToken);
        }
    }

    componentWillUnmount(){
        try {
            removeScrollDown();    
        } catch (error) {
            console.log(error);
        }
        
    }

    componentDidMount(){
        const room = localStorage.getItem('room');

        // this.headerForTamassa()
        console.log('this.props.showNewHeader',this.props.showNewHeader);
        if(document.getElementById('header') && !this.props.currentHomePage.label === "NOTIFICATIONS"){
            document.getElementById('header').style.display = 'none'
        }

        if(document.getElementById('notifications') && document.getElementById('fixedInfo')){
            document.getElementById('fixedInfo').style.display = 'none'
        }

        const platform = window.device ? window.device.platform : ''; 

        // console.log("header local storage room",room);
        if(room && room != "null"){

            if(platform == 'Android'){
                const profile_img = localStorage.getItem('profile_photo');
                    if(profile_img && profile_img != 'null'){
                        this.setState({autocheckinSelfie:profile_img});
                    }
            } else {
                setTimeout(() => {
                    const profile_img = localStorage.getItem('profile_photo');
                    if(profile_img && profile_img != 'null'){
                        // alert(`using profile_img: ${profile_img}`);
                        this.setState({autocheckinSelfie:profile_img});
                    }
                }, 1000);
            }
            
        }
    } 

    render() {
        let profileImage = `${CMSPath}${this.props.profile.profileImageUrl}`
        let greetingLine1 = this.getLine1()
        let greetingLine2 = this.getLine2()
        
        scrollDownEffect("app-body","header",this.props.menuColor,13,this.refreshNotification);
       


        return (
            <div id="fixedInfo" class="fixedInfo" style={{Display: "block"}}>
                {`${this.props.GreetingFromParent ? (this.props.GreetingFromParent).replace('Hi ','') : greetingLine1.replace('Hi ','')}`}
                <span class={`floating-guest-photo ${this.room && this.room !== "null" ? "logged-in" : ""}`}
                      style={{backgroundImage: this.state.autocheckinSelfie && this.state.autocheckinSelfie != "null" ? `url(${this.state.autocheckinSelfie})` : `url('${profileImage}')`,
                      backgroundPosition: 'center',
                      backgroundSize: "cover",
                      backgroundRepeat:"no-repeat",
                    }}
                    onClick={this.profileClick}
                      ></span>
                {this.state.changeProfileImage ?  <HashRouter>
                    <Redirect exact to = "/change_profile_photo"/>
                </HashRouter> : null}
            </div>
        )
    }
}

StickyHeader.propTypes = {
    PageNameFromParent: PropTypes.string,
    GreetingFromParent: PropTypes.string
}

StickyHeader.defaultProps = {
    PageNameFromParent: "",
    GreetingFromParent: ""
}


const mapStateToProps = state => {
    return {
        selectedHomePage: state.store2.currentHomePage,
        showNewHeader: state.store2.showNewHeader,
        profile: state.store.home.currentDuration.brandingInfo.app ?
            state.store.home.currentDuration.brandingInfo.app.profileWidget : {},
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        guestName: state.store.home.guestDetails ?
            state.store.home.guestDetails.guestName : null,
        selfieVideo: state.store2.selfieVideo,
        menuColor: state.store.home.MenuColor,
        currentHomePage: state.store2.currentHomePage,
    }
}
export default connect(
    mapStateToProps,
    {
        setAdminLoginPage,
        showConfirmationPage,
        setRegPage,
        guestJourneyNotification
    }
)(StickyHeader);